import React from 'react';
import classNames from 'classnames';
import CrossRegular from 'jl-ui-kit/elements/icons/CrossRegular';
import BurgerRegular from 'jl-ui-kit/elements/icons/BurgerRegular';
// eslint-disable-next-line import/no-named-as-default
import AccountLinks from '../account-links/AccountLinks';
// eslint-disable-next-line import/no-named-as-default
import Basket from '../basket/Basket';

import styles from './user-tools.scss';

function UserTools({ isMenuOpen, onMenuButtonClick }) {
  const menuButtonChildren = (
    <>
      <span className={styles.visuallyHidden}>
        {isMenuOpen ? 'Close' : 'Menu'}
      </span>
      {isMenuOpen ? <CrossRegular box /> : <BurgerRegular box />}
      <span className={styles.navListItemLabel}>Menu</span>
    </>
  );

  return (
    <nav className={styles.nav}>
      <ul className={styles.navList}>
        <li className={styles.navListItem}>
          <AccountLinks showGreeting />
        </li>
        <li className={styles.navListItem}>
          <Basket>
            <span className={styles.navListItemLabel}>Basket</span>
          </Basket>
        </li>
        <li className={classNames(styles.navListItem, styles.menu)}>
          <a
            href="/menu"
            className={styles.navListItemLink}
            data-test="nav-link--menu"
            onClick={onMenuButtonClick}
            role="button"
            aria-expanded={isMenuOpen}
            aria-controls="main-navigation-menu"
          >
            {menuButtonChildren}
          </a>
        </li>
      </ul>
    </nav>
  );
}

export default UserTools;
